import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { closeReasonsApi } from '@/lib/api';

export function useCloseReasons() {
  return useQuery({
    queryKey: ['close-reasons'],
    queryFn: closeReasonsApi.list,
  });
}

export function useCreateCloseReason() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: closeReasonsApi.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['close-reasons'] });
    },
  });
}

export function useUpdateCloseReason() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof closeReasonsApi.update>[1] }) =>
      closeReasonsApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['close-reasons'] });
    },
  });
}

export function useDeleteCloseReason() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: closeReasonsApi.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['close-reasons'] });
    },
  });
}
